import React, { useCallback } from 'react';
import ShoppingBagIcon from '@moda/icons/shopping-bag-24';
import classNames from 'classnames';
import { useCart } from '../../hooks/useCart';
import { Link } from '../Link';
import { hrefFor } from '../../routers';
import { tc } from '../../lib/trackingContext';

import './MiniCartLink.scss';

type Props = {
  isExpanded?: boolean;
};

export const MiniCartLink: React.FC<Props> = ({ isExpanded }) => {
  const {
    cart: {
      attributes: { cartItemsCount }
    }
  } = useCart({ ssr: false });

  const trackHrefClick = useCallback(() => {
    tc.track('Mini Cart Icon Clicked');
  }, []);

  return (
    <Link
      className={classNames('MiniCartLink', { 'MiniCartLink--with-count': cartItemsCount > 0 })}
      onClick={trackHrefClick}
      to={hrefFor.ShoppingBagPage()}
      aria-label={
        cartItemsCount > 0
          ? `Shopping Bag, ${cartItemsCount} ${cartItemsCount === 1 ? 'item' : 'items'}`
          : 'Shopping Bag'
      }
      aria-haspopup="dialog"
      aria-expanded={isExpanded}
      aria-controls={isExpanded ? 'minicart-popover' : undefined}
    >
      <ShoppingBagIcon />

      {cartItemsCount > 0 && <div className="MiniCartLink__count">({cartItemsCount})</div>}
    </Link>
  );
};
